import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SectionTitle from '../../components/Common/SectionTitle';
import CounterDefault from '../../components/Elements/Counter/CounterDefault';

const CallUs = () => {
    const [callUsData, setCallUsData] = useState(null); // State to store API response

    // Fetching data from the API
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/callUs')
            .then((response) => {
                setCallUsData(response.data); // Set the fetched data into state
            })
            .catch((error) => {
                console.error('Error fetching Call Us data:', error);
            });
    }, []);

    // If data is not yet loaded, display loading message
    if (!callUsData) {
        return <div>Loading...</div>;
    }

    return (
        <div className="rs-call-us relative pt-120 md-pt-70 md-pb-80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 hidden-md">
                        <div className="image-part">
                            <img src={callUsData.imageUrl} alt="Contact Us" />
                        </div>
                    </div>
                    <div className="col-lg-6 pb-120 md-pb-80">
                        <div className="rs-contact-box text-center">
                            <div className="address-item mb-26">
                                <div className="address-icon">
                                    <i className="fa fa-phone"></i>
                                </div>
                            </div>
                            <SectionTitle
                                sectionClass="sec-title3 text-center"
                                subtitleClass="sub-text"
                                subtitle="CALL US 24/7"
                                titleClass="title"
                                title={callUsData.contactNumber} // Dynamic contact number
                                descClass="desc"
                                description={callUsData.content} // Dynamic content
                            />
                            <div className="btn-part mt-40">
                                <Link className="readon lets-talk" to="/contact">Let's Talk</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* counter area start */}
            <CounterDefault />
            {/* counter area end */}
        </div>
    );
};

export default CallUs;
